module.exports = __webpack_public_path__ + "img/mexico.802abd4e.png";